export function setApiUsersLoading (state, loading = false) {
  state.apiusersLoading = loading
}

export function setApiUsers (state, apiusers) {
  state.apiusers = apiusers.data
  state.apiusersCurrentPage = apiusers.current_page
  state.apiusersLastPage = apiusers.last_page
  state.apiusersPerPage = apiusers.per_page
  state.apiusersTotal = apiusers.total
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
